// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__RCQFY","inputWrap":"CustomTip_inputWrap__3owC-"};